import { render, staticRenderFns } from "./textContainer.vue?vue&type=template&id=aadf9938&scoped=true&"
import script from "./textContainer.vue?vue&type=script&lang=js&"
export * from "./textContainer.vue?vue&type=script&lang=js&"
import style0 from "./textContainer.vue?vue&type=style&index=0&id=aadf9938&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aadf9938",
  null
  
)

export default component.exports